import { useCallback } from "react";
import { selfServeUserAlert } from "models/messages";
import { ONBOARDING_STEPS, SurveyFormData } from "types/onboarding";
import { UploadProduct } from "types/products";
import { auth } from "firebaseClient";
import { useSigilLinks } from "hooks/useSigilLinks";

type Step = keyof typeof ONBOARDING_STEPS;

export type SendAlertArgs = {
  customerName: string;
  step: Step;
  survey?: SurveyFormData;
  catalog?: UploadProduct[];
  recipients?: string[];
};

export const useSelfServeAlert = () => {
  const { links } = useSigilLinks();

  const sendAlert = useCallback(
    ({ customerName, step, survey, catalog, recipients }: SendAlertArgs) => {
      if (!auth.currentUser) throw new Error("No authenticated user");
      const defaultMessageTo = [links.supportEmail, links.salesEmail].filter(
        Boolean,
      );
      const messageTo =
        recipients && recipients.length > 0 ? recipients : defaultMessageTo;

      if (messageTo.length === 0) {
        throw new Error("No recipients configured for self-serve alerts.");
      }

      return selfServeUserAlert(
        auth,
        customerName,
        step,
        messageTo,
        survey,
        catalog,
      );
    },
    [links],
  );

  return { sendAlert };
};
